import { BusquedaGeoreferencia } from "./BusquedaGeoreferencia";

export class BusquedaEstructuradaNominatim extends BusquedaGeoreferencia{
  nombreParametroDeBusqueda: string
  pais: string;
  estado: string;
  municipio: string;
  delegacion: string;
  localidad: string;
  colonia: string;
  calle: string;
  numeroExterior: string;
  cp: string;

  constructor(){
    super();
    this.pais="México";
    this.nombreParametroDeBusqueda = "q=";
  }

  public getBusquedaEstructurada(): string{
    let query = "search?";
    if(this.pais && this.pais.trim() !== ""){
      query = query + "country=" + this.pais + "&";
    }
    if(this.estado && this.estado.trim() !== ""){
      query = query + "state=" + this.estado + "&";
    }
    if(this.municipio && this.municipio.trim() !== ""){
      query = query + "county=" + this.municipio + "&";
    }
    if(this.localidad && this.localidad.trim() !== ""){
      query = query + "city=" + this.localidad + "&";
    }
    if(this.calle && this.calle.trim() !== ""){
      query = query + "street=" + this.calle + "&";
    }
    if(this.cp && this.cp.trim() !== ""){
      query = query + "postalcode=" + this.cp + "&";
    }
    query = query + "format=jsonv2";
    return query;
  }

  public getBusquedaSimple(){
    let query = "search?q=";

    if(this.calle && this.calle.trim() !== ""){
      query = query + this.calle + ", ";
    }

    //colonia
    if(this.localidad && this.localidad.trim() !== ""){
      query = query + this.localidad + ", ";
    }

    if(this.municipio && this.municipio.trim() !== ""){
      query = query + this.municipio + ", ";
    }

    if(this.estado && this.estado.trim() !== ""){
      query = query + this.estado + ", ";
    }

    if(this.cp && this.cp.trim() !== ""){
      query = query + this.cp + ", ";
    }

    if(this.pais && this.pais.trim() !== ""){
      query = query + this.pais + ", ";
    }
    query = query + "&format=geojson&polygon_geojson=1";
    return query;
  }
}
